<template>
  <v-simple-table
    class="rounded-card pb-3 overflow-hidden"
    fixed-header
  >
    <template v-slot:default>
      <thead>
      <tr>
        <th>Código interno</th>
        <th style="min-width: 300px">Produto</th>
        <th>Quantidade</th>
        <th>Centro de custo</th>
        <th class="text-center" style="min-width: 100px"></th>
      </tr>
      </thead>
      <tbody>
      <tr style="height: 55px" v-for="(produto) in aprovacao.produtos" :key="produto.id">
        <td>
          <v-icon color="amber darken-1" small class="mb-1 mr-1">
            mdi-clock
          </v-icon>
          {{ codigoProduto(produto) }}
        </td>
        <td>
          {{ descricaoProduto(produto) }}
        </td>
        <td>
          {{
            produto.quantidade
              | number(getCurrencyFormat(casasDecimaisItem(produto)))
          }}
          {{ produto.unidadeMedida.descricao }}
        </td>
        <td>
          {{ produto.centroCusto ? produto.centroCusto.descricao : '-' }}
        </td>
        <td class="text-right">
          <px-anexo read-only
                    v-model="produto.arquivos"
                    download-base-path="files/download-comprador"/>
          <px-detalhes-produto
            :produto="produto"
            show-projeto
            show-obs-externa
            show-obs-interna>
            <template v-slot:bottom>
              <px-campos-integracao
                v-if="cadastrosAdicionaisItem(produto) && erpCamposIntegracao"
                type="requisicao-produtos-view"
                :form-data="cadastrosAdicionaisItem(produto)"/>
            </template>
          </px-detalhes-produto>
          <v-btn icon color="success" class="ml-1">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn icon color="error">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <px-aprovacao-solicitacao-detalhes-produto-modal-view :item-id="produto.id"
                                                                :aprovacao-id="aprovacao.id"/>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import AprovacaoSolicitacaoDetalhesProdutoModalView
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProdutoModalView.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    descricaoProduto() {
      return item => (item.produto ? item.produto.descricao : item.especificacaoProduto);
    },
    codigoProduto() {
      return item => (item.produto ? item.produto.codigo : '-');
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casasDecimaisItem() {
      return item => (item.produto ? item.produto.casasDecimais : null);
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesProdutoModalView: AprovacaoSolicitacaoDetalhesProdutoModalView,
  },
};
</script>
